/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import {
    CONFIRMATION_BOX_BTN_IDS,
    DIALOG_REPO_KEYS,
} from './confirmationDialogConstants';
import CONFIRMATION_CTAS_REPO from './confirmationDialogActionsRepo';
import {
    AppDialogAction, AppDialogDescription,
} from '../../../../stores/dialog';
import TranslationUtil from '../../../translation';
import AppModelMapper from '..';
import { APP_DIALOG } from '../../../enums';

import {
	 ACTION_ID,
} from '../appModelConstants';
import './confirmationDialog.scss';

class ConflictProcessModelMapper {
    updateDialogRepo(appData, onAction) {
        const { confirmationDetails } = appData;
        let heading;
        if (!AppModelMapper.actionCommandToStatusString(appData)) {
            heading = TranslationUtil.getMessage('ccx.confirmation.conflict.updateAll.title');
        } else {
            heading = TranslationUtil.getMessage('ccx.confirmation.conflict.title',
                {
                    actionName: AppModelMapper.actionCommandToStatusString(appData, true),
                    appName: appData.display_name,
                });
        }
	    const conflictDialogDesc = (
            <div>{TranslationUtil.getMessage('ccx.confirmation.conflict.desc')}
	    <span className="learn-more-conflict" onClick={() => onAction(ACTION_ID.LEARN_MORE, DIALOG_REPO_KEYS.CONFLICT)}>
		    {TranslationUtil.getMessage('ccx.appAction.learnMore')}
	    </span>
            </div>
        );
        const description = [
            new AppDialogDescription(APP_DIALOG.DESCRIPTION_TYPE.PARAGRAPH, conflictDialogDesc),
        ];
        const { conflictingProcessesList } = confirmationDetails.confirmationBody;
        if (conflictingProcessesList) {
            conflictingProcessesList.split(',').forEach((apps) => {
                description.push(new AppDialogDescription(APP_DIALOG.DESCRIPTION_TYPE.PARAGRAPH, `- ${apps}`));
            });
        }
        const actionList = [];
        confirmationDetails.confirmationButtons.map((btnInConfirmationBox) => {
            if (!btnInConfirmationBox.id) {
                return null;
            }
            switch (btnInConfirmationBox.id.toLowerCase()) {
            case CONFIRMATION_BOX_BTN_IDS.PRIMARY:
	            actionList.push(new AppDialogAction({
		            localizedText: TranslationUtil.getMessage('ccx.confirmation.btn.continue'),
		            ariaLabel: 'Continue',
		            ...CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.PRIMARY],
	            }));
	            break;
            case CONFIRMATION_BOX_BTN_IDS.TERTIARY:
	            actionList.push(new AppDialogAction({
		            localizedText: TranslationUtil.getMessage('ccx.confirmation.btn.cancel'),
		            ariaLabel: 'Cancel',
		            ...CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.TERTIARY],
	            }));
	            break;
            default:
                break;
            }
            return null;
        });
        return {
            heading, description, actionList,
        };
    }
}
export default new ConflictProcessModelMapper();
